import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { NotificationService } from '../../../shared/notification.service';
import { CaseProperty } from '../case-property';
import { CasePropertyService } from '../case-property.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-case-property-list',
  templateUrl: 'list.component.html',
  styleUrls: ['list.component.css'],
})
export class CasePropertyListComponent implements OnInit {
  @Input() caseRefreshed: EventEmitter<string>;

  @Input() caseId: string;

  public caseProperties: CaseProperty[] = [];

  public isLoading: boolean = true;

  public totalPages: number = 1;

  public currentPage: number = 1;

  public totalResults: number = 0;

  public itemDeleted: EventEmitter<boolean> = new EventEmitter<boolean>();

  public propertyCreated: EventEmitter<boolean> = new EventEmitter<boolean>();

  public newProperty: CaseProperty = new CaseProperty();

  public editorOptions = {
    placeholder: 'Enter your note...',
    modules: {
      toolbar: ['bold', 'link'],
    },
  };

  constructor(
    private casePropertyService: CasePropertyService,
    private notificationService: NotificationService,
    public authService: AuthService,
  ) {
    this.casePropertyService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
    this.casePropertyService.totalPages.subscribe(totalPages => {
      this.totalPages = totalPages;
    });
    this.casePropertyService.currentPage.subscribe(currentPage => {
      this.currentPage = currentPage;
    });
    this.casePropertyService.totalResults.subscribe(totalResults => {
      this.totalResults = totalResults;
    });
  }

  public ngOnInit(): void {
    this.loadCaseProperties(1);
    this.caseRefreshed.subscribe(id => {
      this.caseId = id;
      this.onPageChanged(1);
    });
  }

  public onPageChanged(pageNumber: number): void {
    this.loadCaseProperties(pageNumber);
  }

  public loadCaseProperties(page?: number, limit?: number): void {
    const listCountries = this.casePropertyService
      .listCaseProperties(page, limit, { parameters: { id: this.caseId } })
      .subscribe((caseProperties: CaseProperty[]) => {
        this.caseProperties = caseProperties;
        listCountries.unsubscribe();
      });
  }

  public create(formData: CaseProperty) {
    this.casePropertyService
      .createCaseProperty(this.newProperty, { parameters: { id: this.caseId } })
      .subscribe(results => {
        this.propertyCreated.next(true);
        this.onPageChanged(1);
      });
    console.log('creating', this.newProperty);
  }

  public delete(id: string) {
    this.casePropertyService.deleteCaseProperty(id).subscribe(
      deleted => {
        this.notificationService.success(
          `Property Deleted`,
          `Vehicle with ID ${id} was deleted.`,
          5,
        );
        this.itemDeleted.next(true);
        this.onPageChanged(this.currentPage);
      },
      err => {
        this.notificationService.error(
          `Property Not Deleted`,
          err.error.message,
          10,
        );
        this.itemDeleted.next(false);
        this.onPageChanged(this.currentPage);
      },
    );
  }
}
